import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBindBaseEntity} from 'models';
import {prefix} from './config';
import {toastNotificationManager} from 'toast-notifications';

export const fetchSessionsByProgramIdsThunk: any = createAsyncThunk<IBindBaseEntity[], number[]>(
  `${prefix} fetchSessionsByProgramIds`,
  async (payload: number[], {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getSessionsByProgramIds(payload);
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch sessions. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
